import React, { Fragment } from 'react';
import { Edit } from 'react-admin';
import PlotTabs from './Tabs';

const PlotEdit = (props) => {
  const { resource } = props;

  return (
    <Fragment>
      <Edit
        title={`resources.plot.titles.edit`}
        mutationMode="optimistic"
        {...props}
      >
        <PlotTabs {...props} />
      </Edit>
    </Fragment>
  );
};

export default PlotEdit;
